import { render, staticRenderFns } from "./contractDetailHisFee.vue?vue&type=template&id=37d89fae&scoped=true"
import script from "./contractDetailHisFee.vue?vue&type=script&lang=js"
export * from "./contractDetailHisFee.vue?vue&type=script&lang=js"
import style0 from "./contractDetailHisFee.vue?vue&type=style&index=0&id=37d89fae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d89fae",
  null
  
)

export default component.exports